import { KYMW1313Model } from '../kymw1313.model';
import { KYMW1313GetSetPlanPromotionGoodsInfoModel } from '../vo/kymw1313-get-set-plan-promotion-goods-info.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * バンドルミックスマッチ画面　プロモーション商品情報を取得するサービス
 *
 * @export GetSetPlanPromotionGoodsListService
 * @class GetSetPlanPromotionGoodsListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetSetPlanPromotionGoodsListService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1313Model}
   * @memberof GetSetPlanPromotionGoodsListService
   */
  private model: KYMW1313Model;

  /**
   * 処理に使用するvo
   *
   * @private
   * @type {KYMW1313GetSetPlanPromotionGoodsInfoModel}
   * @memberof GetSetPlanPromotionGoodsListService
   */
  private vo: KYMW1313GetSetPlanPromotionGoodsInfoModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSetPlanPromotionGoodsListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        PromotionNo: this.vo.promotionNo,
        PromotionDiv: this.vo.promotionDiv,
        PromotionName: this.vo.promotionName,
        SetDelivGoodsName: this.vo.setDelivGoodsName,
        PCode: this.vo.pCode,
        CoopCode: this.vo.coopCode,
        ClassCode: this.vo.classCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetSetPlanPromotionGoodsListService
   */
  execute(model: any, vo: any): void {
    this.model = <KYMW1313Model>model;
    this.vo = vo;
    this.send('getSetPlanPromotionGoodsList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSetPlanPromotionGoodsListService
   */
  success(data: any): void {
    this.model.updateKYMW1313(data);
    this.model.kymw1313Component.btn_Search.nativeElement.focus();
  }
}
